import script from "./inputField.vue?vue&type=script&setup=true&lang=ts"
export * from "./inputField.vue?vue&type=script&setup=true&lang=ts"

import "./inputField.vue?vue&type=style&index=0&id=fb5f8fe0&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb5f8fe0"]])

export default __exports__